// DON'T DELETE THIS COMMENT CODE
// export enum TransactionStatusEnum {
//   //TAB ACTIVE
//   active = 'active',

//   // TAB NEED APPROVAL
//   void_draft = 'void_draft',
//   draft = 'draft',
//   pending_approval = 'pending_approval',
//   pending_void_approval = 'pending_void_approval',

//   // TAB REJECTED APPROVAL
//   rejected_approval = 'rejected_approval',

//   // TAB VOID
//   void = 'void',

//   // HIDDEN
//   waiting = 'waiting',
//   archived = 'archived',
// }

export enum TransactionTabEnum {
  Active = 'active',
  NeedApproval = 'need_approval',
  RejectedApproval = 'rejected_approval',
  Void = 'void',
}
